import React from 'react';
import Image from '../../Components/ImageBlurFallback';
import './style.css';
import WORKSHOP_BANNER from '../../Assets/v2/workshop/Frame.png';

const Banner = () => (
  <section className="workshop-banner-parent-container">
    <div className="workshop-banner-child-container">
      <div className="workshop-banner-child-left">
        {/* <div className="workshop-banner-logoContainer">
          <div className="workshop-banner-logo">
            <Image src="{ISB_OG_LOGO}" alt="isb logo" className="image" />
          </div>
          <div className="workshop-banner-logo2">
            <Image
              src="{RENDEZVOUS_LOGO}"
              alt="Rendezvous IIT bhubaneswar logo"
              className="image"
            />
          </div>
        </div> */}
        <h1>
          <span className="workshop-banner-header-text">
            Your Growth is
            <br /> just&nbsp;
            <span className="workshop-banner-colorful-text">one click</span>
            <br />
            Away!
          </span>
        </h1>
      </div>
      <div className="workshop-banner-child-right">
        <Image
          src={WORKSHOP_BANNER}
          alt="Meet and Greet"
          className="workshop-banner-right-image"
        />
      </div>
    </div>
    <div className="banner-footer">
      <p>Participate, Perform and Grab Internships today with our workshops</p>
    </div>
  </section>
);

export default Banner;



// WEBPACK FOOTER //
// ./src/Pages/Workshop/Banner.js